import { List } from 'immutable';
import { getMostSpecificPathFromKeys, getPathKeyLength } from 'automation-ui-log-events/utils/messagePathUtils';
import { NonspecificTypeKey } from 'automation-ui-log-events/constants/LogEventMessageConstants';
import { getFailType, getFilterEventType, getTriggerEnrollType } from 'automation-ui-log-events/records/LogEvent/utils';
import { LogEventTypes, EnrollmentStates } from 'automation-ui-log-events/constants/LogEventConstants';
import { getSpecialType } from './defaultMessageUtils';
export const getLogEventPrimaryMessageKeys = (logEvent, objectTypeId) => {
  const failType = getFailType(logEvent);
  const specialType = getSpecialType(logEvent, objectTypeId);
  const triggerEnrollType = getTriggerEnrollType(logEvent);
  return List([LogEventTypes.ENROLLMENT, EnrollmentStates.ENROLLED, triggerEnrollType, failType || specialType, objectTypeId]);
};
export const getLogEventPrimaryMessage = (logEvent, objectTypeId) => {
  const preenrollMessage = getMostSpecificPathFromKeys(getLogEventPrimaryMessageKeys(logEvent, objectTypeId));
  if (!preenrollMessage || getPathKeyLength(preenrollMessage.path) < 3) {
    return undefined;
  }
  return preenrollMessage;
};
export const getLogEventSecondaryMessageKeys = (logEvent, objectTypeId) => {
  const filterEventType = getFilterEventType(logEvent);
  return List([LogEventTypes.PRE_ENROLLMENT, NonspecificTypeKey, filterEventType, objectTypeId]);
};
export const getLogEventSecondaryMessage = (logEvent, objectTypeId) => {
  const preenrollMessage = getMostSpecificPathFromKeys(getLogEventSecondaryMessageKeys(logEvent, objectTypeId));
  if (!preenrollMessage || getPathKeyLength(preenrollMessage.path) < 3) {
    return undefined;
  }
  return preenrollMessage;
};